require('./scatter-chart.jade')
_ = require('lodash')

renderGoal = (goal) ->
  return unless goal
  xAxis = @xAxis[0]
  yAxis = @yAxis[0]
  path = [
    'M',
    xAxis.toPixels(xAxis.min) - 100, yAxis.toPixels(goal.total_shot_all_holes),
    'L',
    xAxis.toPixels(goal.total_putt_all_holes), yAxis.toPixels(goal.total_shot_all_holes),
    xAxis.toPixels(goal.total_putt_all_holes), yAxis.toPixels(yAxis.min) + 100,
  ]
  @renderer.path(path)
    .attr
      'stroke-width': 2
      stroke: 'red'
      dashstyle: 'line'
      zIndex: 4
      gridLineWidth: 1,
      gridZIndex: 4
    .add()
  @renderer.label(goal.total_putt_all_holes.toFixed(2),
    xAxis.toPixels(goal.total_putt_all_holes), yAxis.toPixels(yAxis.min) - 8)
    .css
      fontWeight: 'bold'
      color: 'red'
    .attr
      zIndex: 4
      gridLineWidth: 1,
      gridZIndex: 4
    .add()
  @renderer.label(goal.total_shot_all_holes.toFixed(2),
    xAxis.toPixels(xAxis.min) - 10, yAxis.toPixels(goal.total_shot_all_holes))
    .css
      fontWeight: 'bold'
      color: 'red'
    .attr
      zIndex: 4
      gridLineWidth: 1,
      gridZIndex: 4
    .add()

createChartOptions = (scoreData, goal, range, target) ->
  chart:
    renderTo: target[0]
    type: 'scatter'
    backgroundColor: 'transparent'
    events:
      load: ->
        renderGoal.call(@, goal)
  credits:
    enabled: false
  title:
    text: null
  xAxis:
    min: range.xRange.min
    max: range.xRange.max
    title:
      enabled: false
    labels:
      enabled: false
    gridLineWidth: 0
    lineWidth: 0
    tickWidth: 0
  yAxis:
    min: range.yRange.min
    max: range.yRange.max
    title:
      enabled: false
    labels:
      enabled: false
    gridLineWidth: 0
    lineWidth: 0
    tickWidth: 0
  legend:
    enabled: false
  plotOptions:
    scatter:
      marker:
        radius: 5
        states:
          hover:
            enabled: true
            lineColor: 'rgb(100,100,100)'
      states:
        hover:
          marker:
            enabled: false
      tooltip:
        headerFormat: ''
        pointFormat: '''
        <span style="color: #00B2AF; font-size: 12px; font-weight: bold;">{point.play_date}</span>
        <br />{point.name}<br />
        <span style="color: #00B2AF; font-size: 14px; font-weight: bold;">{point.y}
          <span style="color: #00B2AF; font-size: 12px; font-weight: bold;">{point.x}</span>
        </span>
        '''
  series: [
    color: '#00B2AF'
    data: scoreData
  ]

ScatterChartDirective = (ScatterDataService) ->
  restrict: "A"
  replace: false
  templateUrl: "analysis/scatter-data/scatter-chart.jade"
  scope:
    scoreData: '=scoreData'
    goal: '='
  link: (scope, element) ->
    target = element.find(".chart")
    scope.$watch "scoreData", ->
      scoreData = ScatterDataService.convertScoreCards(scope.scoreData)
      range = ScatterDataService.calculateRange(scoreData, scope.goal)
      new Highcharts.Chart createChartOptions scoreData, scope.goal, range, target

ScatterChartDirective.$inject = [
  "ScatterDataService"
]

module.exports = ScatterChartDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis/scatter-data/scatter-chart-directive.coffee